import { historyStore } from './stores'

const KEY = 'historyPosts'
const FAILED_KEY = 'historyPostsWriteFailed'

// MAX 는 되찾을 수 있어야 하는 범위에서 왔다 — 하루 20~40 개를 클릭한다면 한두 달치다.
// 클릭마다 목록 전체를 다시 쓰고 다시보기와 저장 공간을 나눠 쓰므로, 키우면 두 비용이
// 함께 는다.
const MAX = 1000

// brokenOnLoad 는 읽기 실패를 화면이 알리도록 남긴다. init 은 화면이 그려지기 전에 돌아
// 그 자리에서 알릴 수 없다. 같은 페이지 로드 안에서 화면이 읽어 가므로 모듈 변수로 충분하다.
let brokenOnLoad = false

// init 은 저장소가 깨져 있어도 앱이 뜨게 한다. 이 호출은 모듈 최상위라 여기서 예외가
// 나가면 번들 평가가 끊겨 화면 전체가 백지가 된다.
export function init() {
  const raw = window.localStorage.getItem(KEY)
  if (!raw) {
    return
  }
  let parsed
  try {
    parsed = JSON.parse(raw)
  } catch (e) {
    brokenOnLoad = true
    return
  }
  if (!Array.isArray(parsed)) {
    brokenOnLoad = true
    return
  }
  historyStore.replace(normalize(parsed))
}

// add 는 저장이 성공한 뒤에야 목록을 바꾼다. 반대로 하면 저장이 실패했을 때 화면에는
// 쌓인 것으로 보이는데 새로고침하면 사라진다.
// 이 호출 직후 브라우저는 외부 사이트로 떠나므로 실패를 그 자리에서 알릴 수 없다.
// 대신 표시를 남겨 다음에 봤던글 화면에 들어올 때 알린다.
export function add(post) {
  const next = normalize([...historyStore.posts, project(post)])
  try {
    save(next)
  } catch (e) {
    markFailed()
    return
  }
  historyStore.replace(next)
}

// del 은 화면이 남아 있는 상태에서 불리므로 실패를 그대로 던진다. 화면이 받아 알린다.
export function del(post) {
  const next = historyStore.posts.filter(p => p.url !== post.url)
  if (next.length === historyStore.posts.length) {
    return
  }
  save(next)
  historyStore.replace(next)
}

export function clear() {
  save([])
  historyStore.replace([])
}

// list 는 최신이 위로 오도록 뒤집은 사본을 반환한다 (다시보기의 list 와 같다).
export function list() {
  return historyStore.posts.slice().reverse()
}

export function count() {
  return historyStore.posts.length
}

// wasBroken·takeWriteFailed 는 화면이 실패를 한 번만 알리도록 읽으면서 지운다.
export function wasBroken() {
  const broken = brokenOnLoad
  brokenOnLoad = false
  return broken
}

export function takeWriteFailed() {
  const failed = window.sessionStorage.getItem(FAILED_KEY) !== null
  if (failed) {
    window.sessionStorage.removeItem(FAILED_KEY)
  }
  return failed
}

// project 는 화면에 쓰는 세 값과 열람 시각만 남긴다. Post 인스턴스를 그대로 저장하면
// id·조회수·시각 객체까지 실려 용량이 몇 배가 되고, 그 값들은 시간이 지나면 낡는다.
// seenAt 을 찍는 곳은 여기 하나다.
function project(post) {
  return {
    publisher: post.publisher,
    url: post.url,
    subject: post.subject,
    seenAt: Date.now(),
  }
}

// normalize 는 같은 글의 옛 기록을 지우고 상한을 넘긴 오래된 쪽을 자른다. add 와 init 이
// 같은 규칙을 쓰도록 한 곳에 둔다 — 두 벌이면 앱을 껐다 켤 때마다 목록이 달라진다.
// seenAt 은 여기서 만들지 않는다. 만들면 저장된 열람 시각이 앱 실행 시각으로 덮인다.
function normalize(posts) {
  const urls = new Set()
  const kept = []
  // 뒤가 최신이라 뒤에서부터 훑어야 같은 글의 최신 기록이 남는다.
  for (let i = posts.length - 1; 0 <= i; i--) {
    const post = posts[i]
    if (!post || !post.url || !post.subject || urls.has(post.url)) {
      continue
    }
    urls.add(post.url)
    kept.push(post)
  }
  kept.reverse()
  return MAX < kept.length ? kept.slice(kept.length - MAX) : kept
}

function save(posts) {
  window.localStorage.setItem(KEY, JSON.stringify(posts))
}

// markFailed 가 sessionStorage 를 쓰는 이유는 두 가지다 — 모듈 변수는 외부 사이트로
// 나가면 사라지고, localStorage 는 실패 원인인 저장 공간을 함께 쓴다.
function markFailed() {
  try {
    window.sessionStorage.setItem(FAILED_KEY, '1')
  } catch (e) {
    console.error('봤던글 저장 실패:', e)
  }
}

init()
